export default {
  must_be_unique: 'Name must be unique',
};
